import AppBarModelControl from './behavior/AppBarModelControl';
import MessageExtensionModelControl from './behavior/MessageExtensionModelControl';

import type { ControlModelQuery } from './graphql/queries/__generated__/ControlModel.interface';

export function getStaticBehavior(): ControlModelQuery {
    return {
        views: {
            __typename: 'ViewData',
            ...AppBarModelControl,
            ...MessageExtensionModelControl,
        },
    };
}
